module.exports = __webpack_public_path__ + "img/zu6826.59b05b7d.svg";